import { ReactElement } from 'react'

interface Props {
    activeComponentName: string
    children: Array<ReactElement>
}

export default function SwitchDeviceComponents (props: Props) : JSX.Element {
  // Switch all children and return the "active" one
  return <>{props.children.filter(child => child.props.name === props.activeComponentName)}</>
}
